<div class="document-chat-container flex flex-column">
  <div
    class="chat-content flex-grow-1 overflow-auto"
    #scrollableRef
    (scroll)="onScroll()"
  >
    @for (message of messages; track message; let i = $index) {
      @if (message.role !== "system") {
        <app-documents-space-chat-line
          [username]="message.role"
          [content]="message.content"
        />
      }
    }
  </div>
  <p-messages />

  <div class="chat-input flex align-items-center justify-content-sbetween">
    <app-chat-input
      [disabled]="!isChatEnabled"
      [ngStyle]="{ width: '100%' }"
      [genPending]="genPending"
      [textAreaInput]="userInput"
      (textAreaInputChanged)="onUserInputChanged($event)"
      (sendClick)="onSend()"
      (stopClick)="stopGenerating()"
    />
    <button
      class="p-button-secondary p-button-outlined no-outline text-2xl align-self-end"
      style="border: none; margin-right: 0"
      type="button"
      pButton
      pTooltip="Réinitialiser"
      i18n-pTooltip="@@document_chat_reinitialization_tooltip"
      tooltipPosition="bottom"
      [disabled]="messages.length === 0 || !isChatEnabled"
      label=""
      (click)="resetChat()"
      icon="fa fa-undo"
    ></button>
  </div>
</div>
